import type { PensionFeatureConfig } from '../types/PensionFeatureConfig';

export const pension: PensionFeatureConfig = {
    defaultRoute: 'overview',
    relyOnWebAPIAlias: false,
    overview: {
        visible: true,
        highlights: {
            showOwnerContribution: false,
            showContractEndDate: false,
        },
        highlightedDetails: {
            showAdhesionAct: true,
            showContractNumber: false,
        },
        learnMore: {
            visible: true,
            savingsUrl: 'https://pensiibcr.ro/ro/angajat/pensia-obligatorie',
            supplementaryUrl: 'https://pensiibcr.ro/ro/angajat/pensia-facultativa',
            phone: 'tel://0219503',
            email: 'mailto:pensiibcr@bcr.ro',
        },
    },
    transactions: {
        visible: false,
    },
    funds: {
        visible: false,
    },
};
